import { useI18n } from '../../i18n'
import './SgpBadge.css'

interface SgpBadgeProps {
  className?: string
}

export function SgpBadge({ className = '' }: SgpBadgeProps) {
  const { t } = useI18n()
  return (
    <span
      className={`sgp-badge${className ? ` ${className}` : ''}`}
      role="img"
      aria-label={t('leg.sameGameParlay')}
      title={t('leg.sameGameParlay')}
    >
      {t('leg.sameGameParlayBadge')}
    </span>
  )
}
